import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=0c0e427e&scoped=true&"
import script from "./Bookings.vue?vue&type=script&lang=ts&"
export * from "./Bookings.vue?vue&type=script&lang=ts&"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=0c0e427e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e427e",
  null
  
)

export default component.exports